import { generateDynamicThemeToken } from '../../ThemeProvider';
import { getDynamicThemeToken } from './theme';
import { randomStr } from '../../Shared';
import { focusMaskClass } from '../../Shared/a11yUtils';
export const linkClasses = {
    root: `ui-Link-root-${randomStr()}`,
    focusVisible: 'ui-Link-focusVisible',
    icon: `ui-Link-icon`,
    primary: `ui-Link-primary`,
    secondary: `ui-Link-secondary`,
};
export function getStyle(theme, opts) {
    const dynamicToken = getDynamicThemeToken(theme);
    const [token, tk] = generateDynamicThemeToken({
        componentName: 'Link',
        theme,
        dynamicToken,
    });
    const { type: _type, disabled, underline } = opts;
    const type = _type !== undefined && Object.keys(token.color).includes(_type)
        ? _type
        : 'default';
    const getUnderlineStyle = (isHover) => {
        switch (underline) {
            case 'always':
                return 'underline';
            case 'none':
                return 'none';
            case 'hover':
                return isHover ? 'underline' : 'none';
            default:
                return undefined;
        }
    };
    const rootStyle = {
        display: 'inline-flex',
        alignItems: 'center',
        fontFamily: token.font.family,
        color: tk(token.color[type].default),
        textDecoration: getUnderlineStyle(false) ?? tk(token.textDecoration[type].default),
        textUnderlinePosition: 'under',
        cursor: 'pointer',
        verticalAlign: 'baseline',
        '&:hover': {
            color: tk(token.color[type].hover),
            textDecoration: getUnderlineStyle(true) ?? tk(token.textDecoration[type].hover),
            textUnderlinePosition: 'under',
        },
        '&:active': {
            color: tk(token.color[type].active),
            textDecoration: getUnderlineStyle(true) ?? tk(token.textDecoration[type].active),
        },
        ...(disabled && {
            color: tk(token.color.disabled.default),
            textDecoration: tk(token.textDecoration.disabled.default),
            cursor: 'not-allowed',
            '&:hover': {
                color: tk(token.color.disabled.hover),
                textDecoration: tk(token.textDecoration.disabled.hover),
            },
            '&:active': {
                color: tk(token.color.disabled.active),
                textDecoration: tk(token.textDecoration.disabled.active),
            },
        }),
        [`html.${focusMaskClass} &:focus-visible, body.${focusMaskClass} &:focus-visible`]: {
            outline: tk(token.focusVisible.outline),
            outlineOffset: 2,
            borderRadius: 2,
        },
    };
    const style = {
        [`&.${linkClasses.root}`]: rootStyle,
        [`& .${linkClasses.icon}`]: {
            marginInlineStart: '4px',
        },
    };
    return style;
}
